import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomerAllegationDto } from '../../models/customer-allegation.dto';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerAllegationService {

  constructor(private http: HttpClient) { }

  private readonly path = '/customerAllegation';

  getByBusinessUnit(businessUnitId: string): Observable<CustomerAllegationDto[]> {
    return this.http.get<CustomerAllegationDto[]>(`${environment.apiBaseUrl}${this.path}/${businessUnitId}/businessUnit`);
  }

}
